import { navigate } from '@reach/router';
import React from 'react';
import { Button, ScrollView } from '../components/ui';
import heartChart from '../images/heart-chart.svg';
import logo from '../images/mark-blue.svg';

const WelcomePage = () => (
  <ScrollView>
    <div className="flex flex-column justify-center tc min-vh-100 mw8 center pv5">
      <img src={logo} alt="" style={{ width: 35, height: 37 }} className="db center pb4" />
      <div className="mb4">
        <h1 className="f2 f1-ns display mt0 mb4 mb5-ns" data-testid="welcome-message">
          Welcome to Quala
        </h1>
        <img src={heartChart} alt="" style={{ width: 530, height: 290 }} className="db center" />
      </div>

      <div className="pt4">
        <Button
          data-testid="get-started-button"
          bg="blue"
          color="white"
          className="db mb4"
          onClick={() => navigate('/')}
        >
          Get Started
        </Button>
      </div>
    </div>
  </ScrollView>
);

export default WelcomePage;
